import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  ViewEncapsulation,
} from '@angular/core';
import { EmptyStateBase } from '@qtek/shared/directives';

@Component({
  selector: 'qt-table-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [],
})
export class TableEmptyStateComponent extends EmptyStateBase {
  @HostBinding('class') protected hostClass = 'empty-state';
}
